import '@/assets/css/global.css'
import './index.css'

// import { ReportLog } from '@msb-next/report-log'
import React, { useEffect } from 'react'
import { Toaster } from 'react-hot-toast'
import { BsXLg } from 'react-icons/bs'
import { ReactQueryDevtools } from 'react-query/devtools'
import { ThemeProvider } from 'styled-components'

import { putDevice } from '@/api/login'
import { deviceInfoStore, themeStore, useRecoilState, useRecoilValue } from '@/store'
import { ipcInvoke, windowInfo } from '@/utils/electron'
import { getVisitorId } from '@/utils/tool'

import AddProWx from './components/AddProWx'
import DeviceTest from './components/DeviceTest'
import Modal from './components/Modal'
import useInRoom from './hooks/useInRoom'
import Routes from './router'
import { fromStrState, fundSupervisionPopState } from './store/global'
import { darkTheme, lightTheme } from './theme'

const { isDarkState } = themeStore
const { deviceShowState } = deviceInfoStore

export default function Index() {
  const isDark = useRecoilValue(isDarkState)
  const [deviceShow, setDeviceShow] = useRecoilState(deviceShowState)
  const [_, jumpRoom] = useInRoom()
  const [fundSupervisionPop, setFundSupervisionPop] = useRecoilState(fundSupervisionPopState)
  const [fromStr, setFromStr] = useRecoilState(fromStrState)

  useEffect(() => {
    console.info(`%c Version %c ${import.meta.env.VITE_APP_TIME} `, 'color: #fff; background: #5f5f5f', 'color: #fff; background: #4bc729')

    ipcInvoke('custom', { method: 'screen-info' }).then((result) => {
      if (Array.isArray(result?.data)) {
        const { data: screens } = result
        const [mainWin] = screens
        localStorage.displays = JSON.stringify(screens)
        localStorage.screenWidth = mainWin.width
        localStorage.workAreaWidth = mainWin.workArea.width
        localStorage.screenHeight = mainWin.height
        localStorage.workAreaHeight = mainWin.workArea.height
        localStorage.screenX = mainWin.workArea.x
        localStorage.screenY = mainWin.workArea.y
      }
    })

    // 方式一：普通上报，上报资源加载情况、报错、promise报错、网络情况
    // const console = new ReportLog({
    //   project: 'msb-student-website-' + import.meta.env.VITE_APP_ENV, // 必填 应用名称，取项目名即可，如果需要区分环境，可以使用project-env，也可以只上报线上环境
    //   logging: false,
    //   url: import.meta.env.VITE_APP_SOCKET_URL as string,
    //   cdn: {
    //     socket: 'https://imgvip.meishubao.com/js/socket.io.min.js',
    //     protobuf: 'https://imgvip.meishubao.com/js/protobuf.min.js'
    //   }
    // })
    // window.console = console
  }, [])

  const confirm = () => {
    setFundSupervisionPop(false)
    setFromStr('')
    jumpRoom(fromStr)
  }

  return (
    <ThemeProvider theme={isDark ? darkTheme : lightTheme}>
      {/* 路由 */}
      <Routes />

      {/* 设备检测 */}
      <Modal show={deviceShow} shadowClick={false} header="" footer="" style={{ padding: 0, borderRadius: 25 }} cancel={() => setDeviceShow(false)}>
        <DeviceTest fromPage={''} cancel={() => setDeviceShow(false)} />
      </Modal>

      {/* 资金监管 用户点击弹窗上报 */}
      <Modal shadowClick={true} show={fundSupervisionPop} header="" cancelText="" cancel={confirm} confirm={confirm}>
        <div className="mx-auto my-[20px] w-[300px] relative">
          <div onClick={confirm} className=" absolute top-[-30px] right-[-40px] w-[30px] h-[30px] flex items-center justify-center cursor-pointer text-[#666] anim_btn2">
            <BsXLg />
          </div>
          尊敬的VIP用户您好，本次课程结束后，将根据课程状态扣除课时哦~
        </div>
      </Modal>

      {/* 添加企微 */}
      <AddProWx />

      {/* 全局提示 */}
      <Toaster />

      {/* RQT */}
      <ReactQueryDevtools initialIsOpen={true} />
    </ThemeProvider>
  )
}
